/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';
import type { ICollection } from '../collection-schema';
import { collectionSchema } from '../collection-schema';

export const updateCollectionResponseSchema = createApiResponseSchema(
  collectionSchema,
) as import('zod').ZodSchema<IAPI<ICollection>>;

export type IUpdateCollectionResponse = IAPI<ICollection>;
